export default function NossoNatalPage() {
  const photos = [
    {
      id: 1,
      image: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20christmas%20celebration%20with%20employees%20celebrating%20together%2C%20modern%20office%20decorated%20with%20blue%20and%20white%20christmas%20decorations%2C%20festive%20workplace%20gathering%20with%20christmas%20tree%20and%20lights%2C%20business%20holiday%20party%20atmosphere%2C%20warm%20celebratory%20lighting%2C%20elegant%20professional%20setting&width=800&height=600&seq=natal-sustentare-1&orientation=landscape',
      caption: 'Decoração natalina na empresa'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20christmas%20dinner%20with%20employees%20enjoying%20festive%20meal%20together%2C%20elegant%20catering%20setup%20with%20blue%20and%20white%20christmas%20theme%2C%20professional%20holiday%20celebration%20with%20delicious%20food%2C%20business%20christmas%20party%20dining%2C%20warm%20festive%20atmosphere%2C%20sophisticated%20table%20setting&width=800&height=600&seq=natal-sustentare-2&orientation=landscape',
      caption: 'Ceia de Natal especial'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20secret%20santa%20gift%20exchange%20at%20christmas%20party%2C%20employees%20exchanging%20presents%20with%20blue%20and%20white%20decorations%2C%20professional%20holiday%20celebration%20with%20gift%20giving%2C%20business%20christmas%20gathering%2C%20happy%20colleagues%20with%20wrapped%20presents%2C%20festive%20joyful%20atmosphere&width=800&height=600&seq=natal-sustentare-3&orientation=landscape',
      caption: 'Troca de presentes entre colegas'
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20christmas%20team%20celebration%20with%20employees%20singing%20carols%20and%20celebrating%20together%2C%20modern%20office%20with%20festive%20blue%20and%20white%20christmas%20decorations%2C%20professional%20holiday%20party%20with%20music%20and%20entertainment%2C%20business%20christmas%20gathering%2C%20warm%20cheerful%20atmosphere&width=800&height=600&seq=natal-sustentare-4&orientation=landscape',
      caption: 'Confraternização natalina'
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20christmas%20photo%20session%20with%20employees%20posing%20together%20near%20decorated%20christmas%20tree%2C%20professional%20group%20photo%20with%20blue%20and%20white%20holiday%20decorations%2C%20business%20team%20christmas%20celebration%2C%20colleagues%20celebrating%20holiday%20season%2C%20festive%20professional%20atmosphere&width=800&height=600&seq=natal-sustentare-5&orientation=landscape',
      caption: 'Fotos com a equipe'
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20christmas%20awards%20ceremony%20with%20employees%20receiving%20recognition%20and%20gifts%2C%20modern%20office%20celebration%20with%20blue%20and%20white%20christmas%20theme%2C%20professional%20holiday%20recognition%20event%2C%20business%20christmas%20party%20with%20prize%20giving%2C%20warm%20appreciative%20atmosphere&width=800&height=600&seq=natal-sustentare-6&orientation=landscape',
      caption: 'Premiações e reconhecimentos'
    }
  ];

  const highlights = [
    {
      icon: 'ri-gift-2-line',
      title: 'Amigo Secreto',
      description: 'Troca de presentes entre toda a equipe com muito carinho'
    },
    {
      icon: 'ri-restaurant-2-line',
      title: 'Ceia Especial',
      description: 'Menu natalino completo preparado com dedicação'
    },
    {
      icon: 'ri-music-2-line',
      title: 'Música e Diversão',
      description: 'Apresentações musicais e momentos de descontração'
    },
    {
      icon: 'ri-heart-line',
      title: 'Solidariedade',
      description: 'Ações sociais e campanhas de doação para a comunidade'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20corporate%20christmas%20celebration%20with%20large%20group%20of%20employees%20celebrating%20holiday%20season%20together%2C%20beautifully%20decorated%20modern%20office%20with%20blue%20and%20white%20christmas%20decorations%20and%20lights%2C%20professional%20festive%20workplace%20gathering%20with%20christmas%20tree%2C%20business%20holiday%20party%20atmosphere%2C%20warm%20celebratory%20lighting%2C%20sophisticated%20professional%20setting&width=1920&height=1080&seq=hero-natal-sustentare&orientation=landscape"
            alt="Nosso Natal Sustentare"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <span className="inline-block px-6 py-2 bg-red-600 text-white text-sm font-medium rounded-full mb-6">
            Endomarketing Sustentare
          </span>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Nosso Natal</h1>
          <p className="text-xl md:text-2xl font-light">
            Celebrando o espírito natalino com união, gratidão e solidariedade
          </p>
        </div>
      </section>

      {/* Introdução */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Uma Celebração de Gratidão</h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            O Natal na Sustentare é um momento especial de celebração, união e gratidão. Com decoração temática, 
            ceia especial, troca de presentes e muita confraternização, encerramos o ano fortalecendo os laços 
            entre nossa equipe e celebrando as conquistas alcançadas juntos.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            Esta ação de endomarketing reflete nossos valores de união, respeito e valorização das pessoas, 
            criando um ambiente acolhedor onde todos se sentem parte de uma grande família.
          </p>
        </div>
      </section>

      {/* Destaques */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Destaques da Celebração</h2>
            <p className="text-lg text-gray-600">
              Momentos especiais que marcaram nosso Natal
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {highlights.map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${item.icon} text-4xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Galeria de Fotos */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Galeria de Momentos</h2>
            <p className="text-lg text-gray-600">
              Reviva os melhores momentos da nossa celebração natalina
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {photos.map((photo) => (
              <div
                key={photo.id}
                className="group relative bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={photo.image}
                    alt={photo.caption}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-white text-lg font-medium">{photo.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mensagem Especial */}
      <section className="py-20 px-4 bg-gradient-to-br from-red-50 to-green-50">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-24 h-24 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-8">
            <i className="ri-heart-3-line text-5xl text-white"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Mensagem de Natal</h2>
          <div className="bg-white rounded-xl shadow-lg p-10">
            <p className="text-lg text-gray-700 leading-relaxed mb-6 italic">
              "O Natal é tempo de celebrar as conquistas, agradecer pelas oportunidades e renovar os laços 
              que nos unem. Cada colaborador da Sustentare é parte fundamental da nossa história de sucesso."
            </p>
            <p className="text-lg text-gray-700 leading-relaxed italic">
              "Que o espírito natalino de união, gratidão e solidariedade nos acompanhe durante todo o ano, 
              fortalecendo nossa equipe e inspirando novos desafios."
            </p>
            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-gray-900 font-bold text-xl">Feliz Natal!</p>
              <p className="text-gray-600 mt-2">Equipe Sustentare</p>
            </div>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Nossos Valores Natalinos</h2>
            <p className="text-lg text-gray-600">
              O que o Natal representa para a Sustentare
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">União</h3>
              <p className="text-gray-600">
                Fortalecemos os laços entre nossa equipe, criando um ambiente de colaboração e respeito mútuo.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-3xl text-red-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Gratidão</h3>
              <p className="text-gray-600">
                Reconhecemos e valorizamos o esforço e dedicação de cada colaborador ao longo do ano.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-heart-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Solidariedade</h3>
              <p className="text-gray-600">
                Estendemos o espírito natalino à comunidade através de ações sociais e campanhas de doação.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-red-600 to-green-600">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Pessoas & Cultura Sustentare
          </h2>
          <p className="text-xl text-red-100 mb-8">
            Celebrando juntos os momentos mais especiais do ano.
          </p>
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/')}
            className="bg-white text-red-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Voltar para Home
          </button>
        </div>
      </section>
    </div>
  );
}
